import { render, staticRenderFns } from "./component-third-link.vue?vue&type=template&id=e6f22a68&scoped=true&"
import script from "./component-third-link.vue?vue&type=script&lang=js&"
export * from "./component-third-link.vue?vue&type=script&lang=js&"
import style0 from "./component-third-link.vue?vue&type=style&index=0&id=e6f22a68&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6f22a68",
  null
  
)

export default component.exports